import React, { useState } from "react";
import { Container } from "react-bootstrap";

import { sendEmailToProlitigio } from "../../ses_sendemail";

const Contact = (props) => {
	const [showConfirm, setShowConfirm] = useState(false);

	const [contactForm, setContactForm] = useState({
		nombre: "",
		correo: "",
	});

	const sendEmail = () => {
		sendEmailToProlitigio(
			`Prolitigio - Talleres: ${contactForm.nombre}`,
			<div className="d-flex flex-column">
				<h1>Este es un mensaje automatico de www.prolitigio.org</h1>
				<div className="mt-3">
					{`Nombre: ${contactForm.nombre}`}
					<br />
					{`Correo: ${contactForm.correo}`}
					<br />
					{`Mensaje: Hola, me interesa saber sobre sus proximos talleres.`}
				</div>
			</div>,
			(data) => {
				setShowConfirm(true);
			},
			(error) => {
				alert("Hay un problema con este servicio, por favor intentelo más tarde.");
			},
		);
	};

	return (
		<Container className="py-5">
			<p className="text-justify">
				Llevamos a cabo diferentes tipos de eventos encaminados a fortalecer la Cultura Jurídica. Nos hemos enfocado en organizar
				talleres de capacitación para estudiantes, litigantes y servidores públicos que busquen mejorar sus técnicas de litigación
				oral. Nuestra filosofía es "Aprender...haciendo" por lo cual nuestros talleres son especializados y de cupo limitado para
				que cada participante tenga la oportunidad de aprovechar al máximo cada taller.
			</p>
			<p className="text-justify mt-4">
				Debido a la emergencia sanitaria se han suspendido los talleres presenciales, próximamente estaremos anunciando nuestra
				siguiente capacitación.
			</p>
			<div className="d-flex flex-column align-items-center mt-2">
				<p className="my-4 align-self-start align-self-lg-center">Suscríbete y sé el primero en enterarte del próximo taller</p>
				<div className="d-flex flex-column flex-md-row col-12 col-lg-7 p-0">
					<input
						placeholder="Nombre Completo *"
						type="text"
						className="form-control my-2 my-md-0 mr-md-3"
						value={contactForm.nombre}
						onChange={(e) => {
							const value = e.target.value;
							setContactForm({ ...contactForm, nombre: value });
						}}
					/>
					<input
						placeholder="Correo electrónico *"
						type="text"
						className="form-control my-2 my-md-0 mr-md-3"
						value={contactForm.correo}
						onChange={(e) => {
							const value = e.target.value;
							setContactForm({ ...contactForm, correo: value });
						}}
					/>
					<button
						disabled={contactForm.correo.length < 5 || contactForm.nombre.length < 5}
						type="submit"
						className="text-uppercase btn btn-primary my-2 my-md-0"
						onClick={() => sendEmail()}>
						Suscribirse
					</button>
				</div>
			</div>
			{showConfirm ? (
				<div
					className="modal-backdrop"
					style={{ opacity: 1, background: "rgba(0, 0, 0, 0.5)" }}
					onClick={() => setShowConfirm(false)}>
					<div class="toast" style={{ opacity: "1", float: "right", margin: "20px 40px", backgroundColor: "white" }}>
						<div class="toast-header">
							<strong class="mr-auto text-primary">Mensaje Enviado</strong>
							<button type="button" class="ml-2 mb-1 close" onClick={() => setShowConfirm(false)}>
								&times;
							</button>
						</div>
						<div class="toast-body" style={{ color: "black" }}>
							¡Gracias por contactarnos! Fuiste agregado a nuestra lista de notificaciones.
						</div>
					</div>
				</div>
			) : null}
		</Container>
	);
};

export default Contact;
